import React from 'react'
import { ChromePicker } from 'react-color'
import FixedView from '../FixedView';
import { checkTranslation, translate } from '../../utils/useful';
import { HexAlphaColorPicker } from "react-colorful";

class ColorInput extends React.Component {

    state = {
        displayColorPicker: false,
        show: false
        // color: '#ee5050aa'
    };

    componentDidMount() {
        if (this.props?.displayColorPicker && this.props?.displayColorPicker[this.props?.id]) {
            this.setState({ displayColorPicker: this.props?.displayColorPicker[this.props?.id] })
        }
        setTimeout(() => {
            this.setState({ show: true })
        }, 10);
    }

    handleClick = () => {
        this.setState({ opened: true })
        this.colorPicker.showView()
        //   console.log()
        // this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleOpen = () => {
        this.setState({ displayColorPicker: true })
    }


    handleChange = (e) => {

        let color = e
        // if (e) {
        //     color = e?.hex
        //     if (color != 'transparent' && color) {
        //         color = color + Math.round(e.rgb.a * 255).toString(16)
        //     }
        // }
        // console.log(e.hex + Math.round(e.rgb.a * 255).toString(16))
        // this.setState({ color })
        this.props.changeValue(this.props.header.key, color, this.props.extra)

        // setTimeout(() => {
        //     if (!this.state.opened) {
        //         console.log(this.colorPicker)
        //         if (!this.colorPicker) {
        //             this.setState({ show: false }, () => {
        //                 this.setState({ show: true, opened: true }, () => {
        //                     console.log(this.colorPicker)

        //                     this.colorPicker.showView()
        //                 })
        //             })
        //         } else {
        //             this.setState({ opened: true })
        //             this.colorPicker.showView()
        //         }
        //     }

        // }, 1000);

    }


    chooseFontColor(rawcolor) {
        let color = "#fff"
        if (rawcolor) {
            if (isNaN(Number(rawcolor[1])) || isNaN(Number(rawcolor[3])) || isNaN(Number(rawcolor[5]))) {
                color = "#000"
            }
            if (!isNaN(Number(rawcolor[7])) && Number(rawcolor[7]) < 6) {
                color = "#000"
            }
        }


        return color
    }

    render() {

        return (
            <div className='w-100 h-100'>
                {!this.props.header?.information?.showBox &&
                    <div ref={el => this.currentNode = el} className="w-100 h-100 flexc" >
                        <button onClick={this.handleClick} className={"flexcc p-0 text-start"} style={{ height: '34px', width: '100px', }}>

                            {this.props.data ? (
                                <div className='flexc w-100'>
                                    <div className='mrd-2'>
                                        <div style={{ backgroundColor: this.props.data, border: '1px solid #eee', height: 26, width: 26, borderRadius: 30 }}></div>
                                    </div>
                                    <p className='w-100' style={{ color: '#000' }}>{this.props.data}</p>
                                </div>
                            ) : (
                                <p className='placeholder w-100' >{checkTranslation(this.props.header?.information?.placeholder ?? translate('Choose ...'))}</p>
                            )}
                        </button>
                    </div >
                }


                {this.props.header?.information?.showBox &&
                    <div ref={el => this.currentNode = el} className=" flexc w-100 h-100" >
                        <button onClick={this.handleClick} className={"flexcc p-0 text-start w-100 h-100"} style={{}}>

                            <div style={{ backgroundColor: this.props.data, border: '1px solid #eee', height: 20, width: 20, borderRadius: 30 }}></div>


                        </button>
                    </div >
                }

                {/* {this.state.displayColorPicker && (
                    <div  style={popover}>
                        <div style={cover} onClick={this.handleClose} /> */}

                {this.state.opened && (
                    <div style={{ position: 'fixed', top: 0, left: 0, height: '100%', width: this.props.width, background: '#20202020' }}>

                    </div>
                )}

                {this.state.show && (
                    <FixedView ref={(el) => (this.colorPicker = el)} onHide={() => this.setState({ opened: false })} nodeRef={this.currentNode} showFocus={false} zIndex={10} topOffset={5} xOffset={-10} bottomOffset={30} width={225}>
                        <div className='w-100 shadow-2 br-10 d-flex flex-column' style={{ backgroundColor: '#fff', overflow: 'hidden' }}>
                            <HexAlphaColorPicker color={this.props.data ?? '#fff'} onChange={this.handleChange} />
                            {/* <ChromePicker color={this.props.data ?? '#fff'} onChange={this.handleChange} /> */}
                            <div className='flexc px-2'>
                                <p className='text-bold mrd-1'>#</p>
                                <input pattern='^#(?:[0-9a-fA-F]{3}){1,2}$' className='transparent-input w-100 text-bold  py-2' placeholder='FFFFFF' style={{fontSize:14}} value={this.props.data ? this.props.data.replace('#', '') : ''} onChange={(e)=>this.handleChange("#"+e.target.value)} />
                            </div>
                            <button onClick={() => this.handleChange()} className='w-100  flexc px-3 pb-2 pt-2' style={{ borderTop: '1px solid #eee', backgroundColor: '#fafafa' }}>
                                <p className='text-semibold' style={{ color: '#999' }}>{translate("Clear Color")}</p>
                            </button>
                        </div>
                    </FixedView>
                )}
                {/* </div>
                    )} */}
            </div >
        )
    }
}

export default ColorInput;